import React, {useEffect, useState} from 'react';
import {
    Dialog,
    DialogContent,
    Button,
    Typography,
    Stack,
    IconButton,
    TableCell,
    TableBody,
    TableRow, TableContainer, Paper, Table, TableHead, TablePagination
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import axios from 'axios';
import CaseFileDeclined from "../../enums/CaseFileDeclined";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import CustomAlert from "../ConfirmationModal/CustomAlert";
import "./RewriteRequest.css"
import {MdWaves} from "react-icons/md";
import CaseStatus from "../../enums/CaseStatus";
import CaseNotificationEnum from "../../enums/CaseNotiFicationEnum";

const RewriteRequest = ({selectedCases, selectedCasesFullData, onRequest}) => {
    const [open, setOpen] = useState(false);
    const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertType, setAlertType] = useState('success');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleOpenConfirmationModal = () => {
        setIsConfirmationModalOpen(true);
    };

    const handleCloseConfirmationModal = () => {
        setIsConfirmationModalOpen(false);
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };



    const handleSubmit = async () => {

        const payload = {
            documentPath: "",
            caseRewriteRequestInfos: selectedCases
        };

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/CreateRequest`, payload);
            if (!response.data.success) {
                setShowAlert(true);
                setAlertMessage('გადმოწერის მოთხოვნის გაგზავნა შესაძლებელი 24 საათში ერთხელ');
                setAlertType("error");
                setIsConfirmationModalOpen(false)
                handleClose()
                return;
            }
        } catch (error) {
            setShowAlert(true);
            setAlertMessage("დაფიქსირდა შეცდომა, ცადეთ მოგვიანებით!");
            setAlertType("error");
            return;
        }


        try {
            onRequest()
            handleClose();
            setIsConfirmationModalOpen(false);
        } catch (error) {
            setShowAlert(true);
            setAlertMessage("დაფიქსირდა შეცდომა, ცადეთ მოგვიანებით!");
            setAlertType("error");

        }



    };




    return (
        <div>
            <div style={{alignContent: 'center', justifyContent: 'space-between', gap: 10}}>
                <div className="record-count-box-registery-map slide-in-input">
                    არჩეულია {selectedCases.length} ჩანაწერი
                </div>

                <Button
                    style={{width: 200, marginTop: 10}}
                    variant="contained"
                    color="primary"
                    onClick={handleClickOpen}
                >
                    განაცხადის გადაწერის მოთხოვნა

                </Button>
            </div>
            <Dialog style={{zIndex: 1100}} fullWidth maxWidth="sm" open={open} onClose={handleClose}>
                <DialogContent>
                    <Stack direction="column" spacing={2}>
                        {selectedCasesFullData.length > 0 && (
                            <Paper sx={{ marginTop: 2 }}>
                                <TableContainer>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>განაცხადის ნომერო</TableCell>
                                                <TableCell>განმცხადებელი</TableCell>
                                                <TableCell>ნომენკლატურა</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {selectedCasesFullData
                                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                .map((caseItem) => (
                                                    <TableRow key={caseItem.id}>
                                                        <TableCell>
                                                            <a
                                                                href={`/caseinfo?id=${caseItem.id}`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                style={{ color: '#1a9aef', fontWeight: 'bold', textDecoration: 'none' }}
                                                            >
                                                                {caseItem.caseNumber}
                                                            </a>
                                                        </TableCell>
                                                        <TableCell>{caseItem.requesterName}</TableCell>
                                                        <TableCell>{caseItem.permitTypeTitle}</TableCell>
                                                    </TableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>

                                <TablePagination
                                    component="div"
                                    count={selectedCasesFullData.length}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    rowsPerPage={5}
                                    rowsPerPageOptions={[]}
                                />

                            </Paper>
                        )}
                        <Button variant="contained" color="secondary" onClick={handleOpenConfirmationModal}>
                            გაგზავნა
                        </Button>
                    </Stack>
                </DialogContent>
            </Dialog>
            <ConfirmationModal
                isOpen={isConfirmationModalOpen}
                onRequestClose={handleCloseConfirmationModal}
                onConfirm={handleSubmit}
            />
            {showAlert && (
                <CustomAlert
                    message={alertMessage}
                    type={alertType}
                    onClose={() => setShowAlert(false)}
                />
            )}
        </div>
    );
};

export default RewriteRequest;
